export const APP_STORE_URL = 'https://apps.apple.com/us/app/iden2/id6741362184';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.iden2.wallet&utm_source=na_Med';